import Backbone from 'backbone'
import _ from 'underscore'
import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'
import TitleViewTemplate from '../templates/title.tpl'
import config from '../config'

const TitleView = Backbone.View.extend({
    tagName: 'li',
    id: 'title-view',
    events: {
        'click': 'open',
        'click .test': 'openTest',
        'click .print': 'openPrint',
    },
    initialize() {
        this.template = _.template(TitleViewTemplate)
        this.listenTo(this.model, 'change', this.render)
    },
    render() {
        this.$el.html(this.template(this.model.toJSON()))

        if (this.model.get('test_available') === false && !this.model.get('pdf')) {
            this.$('.open').addClass('full-width')
        }

        if (this.model.get('purchased') === false && this.model.get('free') === false) {
            this.$el.addClass('unlock')
        }

        return this
    },
    open() {
        if (this.model.get('purchased') === false && this.model.get('free') === false) return

        const image_prefix = this.model.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/content/${image_prefix}`, { trigger: true })
    },
    openTest(event) {
        event.stopPropagation()
        const image_prefix = this.model.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/test/${image_prefix}`, { trigger: true })
    },
    openPrint(event) {
        event.stopPropagation()
        const slug = config.get('slug')
        const pdf = this.model.get('pdf')
        const pdfUrl = `/data/${slug}/printables/${pdf}`
        if (Capacitor.getPlatform() !== 'web') {
            Browser.open({ url: pdfUrl })
        } else {
            const pdfWindow = window.open('', '_blank')
            pdfWindow.document.write('Loading...')
            fetch(pdfUrl)
                .then(res => res.blob())
                .then(blob => {
                    pdfWindow.location.href = URL.createObjectURL(blob)
                })
        }
    }
})

export default TitleView
